import { Mapper } from "../../../../core/base";
import { LocationLookup } from "../../../../core/domain";
import { LocationLookupWebEntity } from "./location-lookup-web-entity";

export class LocationLookupWebRepositoryMapper extends Mapper<LocationLookupWebEntity, LocationLookup> {
  mapFrom(param: LocationLookupWebEntity): LocationLookup {
    return {
      id: param.id,
      name: param.name,
      locationId: param.locationId,
      address: param.address,
      locationName:param.locationName,
      locationNameAndAddress:param.locationNameAndAddress,
      sequenceNumber : param.sequenceNumber,
      displayName : param.sequenceNumber + '-' + param.name
    };
  }

  mapTo(param: LocationLookup): LocationLookupWebEntity {
    return {
      id: param.id,
      name: param.name,
      locationId: param.locationId,
      address: param.address,
      locationName:param.locationName,
      locationNameAndAddress: param.locationNameAndAddress,
      sequenceNumber : param.sequenceNumber
    };
  }

}